import { AxiosError } from "axios";

import { api } from "@/lib/axios";

type Platform = {
	id: string;
	name: "Braip" | "Monetizze" | "B4you";
};

export type Integration = {
	id: string | null;
	email: string | null;
	platform: Platform;
	active: boolean;
	email_verified_at: string | null;
};

export async function listIntegrations(): Promise<
	| {
			status: "success";
			data: Integration[];
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get("/integrations-user");

		return {
			status: "success",
			data: data.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
